import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    IAny,
    ICreateActionContext,
    IGeneric
} from '@msdyn365-commerce/core';
import getLocalizationAction, { GetLocalizationInput, INumberFormat } from '../actions/user-preferences/get-localization.action';
export interface ILocalizationState {
    result?: ILocalizationState;
    numberLocale: INumberFormat;
    dateLocale: string;
    preferredUnit?: string;
    timeZone: string;
}

export class LocalizationStateInput implements IActionInput {
    public getCacheKey = () => `LocalizationState`;
    public getCacheObjectType = () => 'LocalizationState';
    public dataCacheType = (): CacheType => 'none';
}

export function localizationStateSetItemAction(_: LocalizationStateInput, localization: ILocalizationState) {
    // Check for window because of serverside runnable functions
    // Check for existance of localization. Otherwise don't write into localStorage
    if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(_.getCacheKey(), JSON.stringify(localization));
    }
}

function localizationStateGetItemAction(_: LocalizationStateInput): string | null {
    if (typeof window !== 'undefined' && window.localStorage) {
        const localization = window.localStorage.getItem(_.getCacheKey());
        if (localization === JSON.stringify({})) {
            window.localStorage.removeItem(_.getCacheKey());
            return null;
        } else {
            return window.localStorage.getItem(_.getCacheKey());
        }
    } else {
        return null;
    }
}

export async function localizationStateAction(_: LocalizationStateInput, ctx: IActionContext): Promise<ILocalizationState> {
    const actionInput = new GetLocalizationInput(ctx);
    const cachedLocalization = localizationStateGetItemAction(_);

    // check for cached localization
    if (cachedLocalization) {
        return JSON.parse(cachedLocalization) as ILocalizationState;
    }

    // otherwise perform data-action to fetch localization settings
    const localization = await getLocalizationAction(actionInput, ctx);

    const localizationState = {
        numberLocale: localization.numberLocale,
        dateLocale: localization.dateLocale,
        preferredUnit: localization.preferredUnit,
        timeZone: localization.timeZone
    };

    // save localization to localstorage
    localizationStateSetItemAction(_, localizationState);

    return localizationState;
}

const createInput = (_: ICreateActionContext<IGeneric<IAny>>): IActionInput => {
    return new LocalizationStateInput();
};

export default createObservableDataAction<ILocalizationState>({
    action: <IAction<ILocalizationState>>localizationStateAction,
    input: createInput
});
